import CalendarEntryIcon from "@mui/icons-material/Event"
import { Button } from "@mui/material"
import React from "react"
import { ButtonProps, Link, useRecordContext } from "react-admin"

export const AddNewYearButton: React.FC<ButtonProps> = (props) => {
  const record = useRecordContext(props)

  return (
    <Button
      color="primary"
      component={Link}
      to={{ pathname: "/quota_limits/create" }}
      state={{ record: { quota_id: record.id } }}
    >
      <CalendarEntryIcon /> Add new year
    </Button>
  )
}
